import React from 'react';
import '../style.css';

function Contact() {
  return (
    <div className="container my-5">
      <h2 className="mb-5 text-center fw-bold" data-aos="fade-down">📞 Contact Us</h2>

      <div className="row">
        {/* Contact Details */}
        <div className="col-md-6 mb-5" data-aos="fade-right">
          <h4>📍 Our Address</h4>
          <p>7/1 tower wali manjil near by new siyaganj nayapura Main road Indore</p>

          <h5 className="mt-4">📧 Email</h5>
          <p><a href="mailto:crescentgraphics7@gmail.com">crescentgraphics7@gmail.com</a></p>

          <h5>📱 Phone</h5>
          <p><a href="tel:+919753036647">+91 97530 36647</a></p>

          {/* WhatsApp */}
          <h5 className="mt-4">💬 WhatsApp</h5>
          <a
            href="https://wa.me/+919753036647"
            className="btn btn-success mt-2"
            target="_blank"
            rel="noopener noreferrer"
          >
            Chat on WhatsApp
          </a>
        </div>

        {/* Google Map */}
        <div className="col-md-6" data-aos="fade-left">
          <h4>🗺️ Location on Map</h4>
          <div className="ratio ratio-4x3 rounded shadow-sm">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3671.7886512982366!2d75.85568097510163!3d22.79125407931045!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3962fc9c04033dd3%3A0xbda353c5ba002d8e!2sNew%20Siyaganj%2C%20Nayapura%20Main%20Rd%2C%20Indore%2C%20Madhya%20Pradesh%20452007!5e0!3m2!1sen!2sin!4v1725200000000!5m2!1sen!2sin"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Shop Location"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
